import {Map, List} from 'immutable';

import {
  RESOURCE_SERVICE_TAG_LIST_REQUEST,
  RESOURCE_SERVICE_TAG_LIST_SUCCESS,
  RESOURCE_SERVICE_TAG_LIST_FAILURE,
  RESOURCE_SERVICE_TAG_READ_REQUEST,
  RESOURCE_SERVICE_TAG_READ_SUCCESS,
  RESOURCE_SERVICE_TAG_READ_FAILURE,
  RESOURCE_SERVICE_TAG_UPDATE_REQUEST,
  RESOURCE_SERVICE_TAG_UPDATE_SUCCESS,
  RESOURCE_SERVICE_TAG_UPDATE_FAILURE,
  RESOURCE_SERVICE_TAG_CREATE_REQUEST,
  RESOURCE_SERVICE_TAG_CREATE_SUCCESS,
  RESOURCE_SERVICE_TAG_CREATE_FAILURE,
  RESOURCE_SERVICE_TAG_DELETE_REQUEST,
  RESOURCE_SERVICE_TAG_DELETE_SUCCESS,
  RESOURCE_SERVICE_TAG_DELETE_FAILURE,
  RESOURCE_SERVICE_TAG_FORM_DESTROY,
  RESOURCE_SERVICE_CSV_DOWNLOAD_REQUEST,
  RESOURCE_SERVICE_CSV_DOWNLOAD_SUCCESS,
  RESOURCE_SERVICE_CSV_DOWNLOAD_FAILURE
} from './actions'
import Logger from '../../../lib/Logger';

export default function resourceServiceTags(
  state=Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {}
  }),
  action
) {
  Logger.log('debug', `[resourceServiceTags.reducers] resourceServiceTags(%j, %j)`, state, action);

  switch(action.type) {

    case RESOURCE_SERVICE_TAG_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case RESOURCE_SERVICE_TAG_LIST_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        pages: {
          [action.order]: {
            [action.limit]: {
              [action.page]: null
            }
          }
        },
        total: action.total,
        lastUpdated: action.receivedAt
      }).setIn(['pages', action.order, action.limit, action.page], List(action.result));

    case RESOURCE_SERVICE_TAG_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case RESOURCE_SERVICE_TAG_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case RESOURCE_SERVICE_TAG_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case RESOURCE_SERVICE_TAG_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case RESOURCE_SERVICE_TAG_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null
        }
      });

    case RESOURCE_SERVICE_TAG_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null
        },
        lastUpdated: action.receivedAt
      });

    case RESOURCE_SERVICE_TAG_UPDATE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: false,
          errors: null
        }
      }).setIn(['form', 'errors'], action.error);

    case RESOURCE_SERVICE_TAG_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null
        }
      });

    case RESOURCE_SERVICE_TAG_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null
        },
        lastUpdated: action.receivedAt
      });

    case RESOURCE_SERVICE_TAG_CREATE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: false,
          errors: null
        }
      }).setIn(['form', 'errors'], action.error);

    case RESOURCE_SERVICE_TAG_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true
      });

    case RESOURCE_SERVICE_TAG_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt
      });

    case RESOURCE_SERVICE_TAG_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false
      });

    case RESOURCE_SERVICE_TAG_FORM_DESTROY:
      return state.mergeDeep({
        form: null
      }).set('form', action.form);

    case RESOURCE_SERVICE_CSV_DOWNLOAD_REQUEST:
      return state.mergeDeep({
        isCSVDownloading: true
      });

    case RESOURCE_SERVICE_CSV_DOWNLOAD_SUCCESS:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    case RESOURCE_SERVICE_CSV_DOWNLOAD_FAILURE:
      return state.mergeDeep({
        isCSVDownloading: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `resourceServiceTags.reducers loaded.`);
